import React from 'react';
import {View, StyleSheet } from '@react-pdf/renderer';
import InvoiceTableHeader from './InvoiceTableHeader'
import InvoiceTableRow from './InvoiceTableRow'
import InvoiceTableBlankSpace from './InvoiceTableBlankSpace'
import InvoiceTableFooter from './InvoiceTableFooter'

const tableRowsCount = 11;

const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 24,
        borderWidth: 1,
        borderColor: '#bff0fd',
    },
});

  const DocumentItemsTable = (props) => {

        return(
          <View style={styles.tableContainer}>
              <InvoiceTableHeader />
              <InvoiceTableRow items={props.document ? props.document.documentLines : null} />
              <InvoiceTableBlankSpace rowsCount={ tableRowsCount - props.document && props.document.documentLines ? props.document.documentLines.length : null} />
              <InvoiceTableFooter items={props.document && props.document.documentLines ? props.document.documentLines : null} />      
          </View>
        )
  };
  
  export default DocumentItemsTable